import { columnsExtend as customColumnExtend } from '@/admin_grapes/order_snapshots.js';
import _ from 'lodash';

const columnsExtendMap = {
  changes_content: {
    label: '修改内容',
    align: 'left',
    renderCell: (h, { props: { value } }) => {
      return <span style="white-space: pre-wrap; word-break: break-all">{value}</span>
    }
  },
  changes_product_image: {
    label: '修改图片',
    width: 120,
    renderCell: 'storageAttachment',
  }
}

export const columnsExtend = (columns) => {
  return customColumnExtend(_.map(columns, (column) => {
    const data = typeof(column) === 'string' ? { key: column } : column

    if (columnsExtendMap[data.key]) {
      return Object.assign({}, columnsExtendMap[data.key], data)
    } else {
      return column
    }
  }))
}
